import { authAxios } from '@components/Auth';
import { snakes } from '@utils/lodash';
import { InsuranceClaim } from '@models/InsuranceClaim';
import { API_V1_BASE } from '@config';
import { paginate } from '@models/Pagination';
import { Pagination, PaginationParams } from '@models/Pagination';
import humps from 'lodash-humps-ts';

export type GetAllClaimParams = PaginationParams & {
  startDate?: string;
  endDate?: string;
  status?: string;
  billingType?: string;
  search?: string;
};

export type GetClaimParams = {
  claimableType: string;
  claimableId: number;
};

export type UpdateClaimParams = GetClaimParams & {
  status: string;
  note: string;
  totalClaimedAmount: number;
  approvedAmount?: number;
};

export type RequestDocumentsParams = {
  claimableType: string;
  claimableId: number;
  documentTypes: string[];
  note?: string;
};

export class InsuranceClaimApi {
  static getAll = async (params = {} as GetAllClaimParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/insurance_claims`, { params: snakes(params) })
      .then((response) => paginate(response) as [InsuranceClaim[], Pagination]);
  };

  static get = async ({ claimableType, claimableId }: GetClaimParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/insurance_claims/${claimableType}/${claimableId}`)
      .then((response) => humps(response.data) as InsuranceClaim);
  };

  static put = async ({ claimableType, claimableId, ...rest }: UpdateClaimParams) => {
    return await authAxios
      .put(`${API_V1_BASE}/user/insurance_claims/${claimableType}/${claimableId}`, snakes(rest))
      .then((response) => humps(response.data) as InsuranceClaim);
  };

  static requestDocuments = async ({ claimableType, claimableId, documentTypes, note }: RequestDocumentsParams) => {
    return await authAxios
      .post(
        `${API_V1_BASE}/user/insurance_claims/${claimableType}/${claimableId}/request_documents`,
        snakes({ documentTypes, note })
      )
      .then((response) => response.data as { success: boolean });
  };
}
